var _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 35.8596,
    fill: "#F4F2E6",
    stroke: "#137078",
    strokeWidth: 1.2807
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5001,
    cy: 36.5005,
    r: 34.5789,
    fill: "#DBEBE6",
    stroke: "#137078",
    strokeWidth: 1.2807,
    strokeDasharray: "1.92 1.92"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5002,
    cy: 36.4997,
    r: 32.3377,
    fill: "#F4F2E6",
    stroke: "#137078",
    strokeWidth: 0.640351
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 7.72656C51.9916 7.72668 64.5635 20.4424 64.5635 36.1445C64.5633 51.8465 51.9915 64.5624 36.5 64.5625C21.0084 64.5625 8.43671 51.8466 8.43652 36.1445C8.43652 20.4423 21.0083 7.72656 36.5 7.72656Z",
    stroke: "#137078",
    strokeWidth: 1.2807
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0397 29.4551L21.9484 32.988H25.0397L22.8316 38.7291H19.2987L16.6489 41.8205H29.0143V38.7291H27.2478L30.3392 29.4551H25.0397Z",
    fill: "#1BA3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9385 41.8205L47.1212 29.4551H53.3039L48.8877 38.2875H55.0704L53.3039 41.8205H40.9385Z",
    fill: "#1BA3B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4712 29.4551H32.5475L31.2226 37.4043H37.8469L37.4053 38.7291H31.2226L30.3394 41.8205H38.7302L42.2631 34.7545H36.0804L36.9637 32.1048H42.7048L44.4712 29.4551Z",
    fill: "#1BA3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBadge);
export default __webpack_public_path__ + "static/media/card-badge.358f56305e1215f7b07f5cf868fc3584.svg";
export { ForwardRef as ReactComponent };